import React from "react";
import PropTypes from "prop-types";
import NotificationWrapper from "notifications/containers/wrapper";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import AllCheckbox from "notifications/containers/all_checkbox";
import ActionSelect from "notifications/containers/action_select";
import MAPPING from "notifications/mapping";

const NotificationsList = ({
  notificationsList,
  showChecks,
  filter,
  emptyMessage,
  grouped,
  showClear,
}) => {
  if (!notificationsList) {
    return null;
  }

  let list = filter ? notificationsList.filter(filter) : notificationsList;
  if (grouped) {
    const groupIndexes = {};
    const groups = list.reduce((acc, notification) => {
      // no grouped notification: each notification shown on its own
      if (!MAPPING?.[notification.n_id]?.grouped) {
        return [...acc, [notification]];
      }
      const groupIndex = groupIndexes[notification.n_id];
      // first notification of a group: create new group
      if (groupIndex === undefined) {
        groupIndexes[notification.n_id] = acc.length;
        return [...acc, [notification]];
      }
      // add notification to existing group
      acc[groupIndex].push(notification);
      return acc;
    }, []);

    list = groups.reduce((acc, group) => {
      // only one notification in group: nothing to be done
      if (group.length === 1) {
        return [...acc, group[0]];
      }
      // multiple notifications in group: process them appropriately
      const processedNotifications = MAPPING[group[0].n_id].processGroup(group);
      return [...acc, ...processedNotifications];
    }, []);
  }

  if (!list.length) {
    return (
      <div className="row">
        <div className="small-16 columns">
          <div className="empty-state no-results">
            <div className="empty-state-container">
              <h3>{emptyMessage || "No notifications"}</h3>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="notifications-list">
      {showChecks && (
        <div className="action-selector hide-for-small-only">
          <div className="row">
            <div className="medium-2 large-1 columns">
              <AllCheckbox notificationsList={list} />
            </div>
            <div className="medium-8 large-4 columns">
              <ActionSelect />
            </div>
          </div>
        </div>
      )}
      <ReactCSSTransitionGroup
        transitionName="new-notification"
        transitionEnterTimeout={250}
        transitionLeaveTimeout={250}
      >
        {list.map((notification) => (
          <NotificationWrapper
            key={notification.uuid}
            notification={notification}
            showChecks={showChecks}
            showClear={showClear}
          />
        ))}
      </ReactCSSTransitionGroup>
    </div>
  );
};

NotificationsList.propTypes = {
  notificationsList: PropTypes.array,
  showChecks: PropTypes.bool,
  filter: PropTypes.func,
  emptyMessage: PropTypes.string,
  grouped: PropTypes.bool,
  showClear: PropTypes.bool,
};

export default NotificationsList;
